import {
  UpdateScreenshotDescriptionRequest,
  UpdateScreenshotDescriptionResponse,
} from '@eigtech/meetings-types'
import { contextualPost, useMutation } from '@eigtech/ui-shared-api'
import { meetingsBasePath } from './constants'
import { useOptimisticSetUploadDescription } from './getMeeting'

const updateScreenshotDescription = ({
  entityId,
  dateAdded,
  startTime,
  description,
  label,
}: UpdateScreenshotDescriptionRequest & { meetingId: string }) =>
  contextualPost<UpdateScreenshotDescriptionResponse>(
    `${meetingsBasePath}/meeting/screenshot/${entityId}/${startTime}/${dateAdded}`,
    { description, label }
  )

// start meeting
export function useUpdateScreenshotDescription() {
  const setDescription = useOptimisticSetUploadDescription()

  return useMutation({
    mutationFn: updateScreenshotDescription,
    onSuccess(__, request) {
      setDescription(request)
    },
  })
}
